import common from '@/components/sheets/import/impl/common'

const createBacteremia = common.createBacteremia(false, false)

function createCatheter (prefix, p) {
  const type = p[`${prefix}Type`]
  if (type == null || type === '') {
    return null
  }

  return {
    central: 1,
    type_v2: common.getValue(type, ['C1', 'C2', 'C4', 'C5', 'C6', 'C7', 'C8', 'D1']),
    insertion: common.newDate(p[`${prefix}Insertion`]),
    insertionSite: common.getValue(
      p[`${prefix}InsertionSite`], [1, 2, 3, 7, 9, 10, 12]
    ),
    removed: common.getValue(p[`${prefix}Removed`], [1, 2, 9]),
    removal: common.newDate(p[`${prefix}Removal`]),
    laboratory: common.getValue(p[`${prefix}Laboratory`], [1, 2, 9]),
    isColIlcBlc: common.getValue(p[`${prefix}IsColIlcBlc`], [0, 1, 2, 3, 4, 9]),
    colIlcBlc: common.newDate(p[`${prefix}ColIlcBlc`]),
    diagDate: common.newDate(p[`${prefix}DiagDate`]),
    origin: common.getValue(p[`${prefix}BactOrigin`], [1, 2, 3, 4, 5, 9]),
    previousManip: common.getValue(p[`${prefix}PreviousManip`], [1, 2, 9]),
    previousManipType: common.getValue(p[`${prefix}PreviousManipType`], [1, 2, 3, 9]),
    previousManipDate: common.newDate(p[`${prefix}PreviousManipDate`]),
    lipids: common.getValue(p[`${prefix}Lipids`], [1, 2, 9]),
    covidStatus: common.getValue(p[`${prefix}Covid`], [1, 2, 3, 9]),
    divDiag: common.getValue(p[`${prefix}DivDiag`], [1, 2, 3, 4, 9]),
    clinicalSigns: common.getValue(p[`${prefix}ClinicalSigns`], [1, 2, 9]),
    bioSigns: common.getValue(p[`${prefix}BioSigns`], [1, 2, 9]),
    adaptedAntibio: common.getValue(p[`${prefix}AdaptedAntibio`], [1, 2, 9]),
    twoHemocs: common.getValue(p[`${prefix}TwoHemocs`], [1, 2, 9]),
    microOrganisms: common.getMicroOrganisms(p, `${prefix}`, false)
  }
}

function createPneumopathy (prefix, p) {
  const episod = p[`${prefix}Episod`]
  if (episod == null || episod === '') {
    return null
  }
  return {
    pneumopathy: 1,
    episod: common.newDate(episod),
    diagDate: common.newDate(p[`${prefix}DiagDate`]),
    origin: common.getValue(p[`${prefix}Origin`], [1, 2, 3, 4, 5, 9]),
    diagnosis: common.getValue(p[`${prefix}Diagnosis`], [1, 2, 3, 4, 5, 9]),
    covidStatus: common.getValue(p[`${prefix}Covid`], [1, 2, 3, 9]),
    microOrganisms: common.getMicroOrganisms(p, `${prefix}`, true)
  }
}

function createBmrBHre (prefix, p) {
  const code = common.getValue(p[`${prefix}Code`], [1, 2, 3, 4, 5, 6, 7, 8])
  if (code == null) {
    return null
  }

  return {
    code: code
  }
}

function createCatheters (p) {
  return common.createList(p, createCatheter, 11, 'kt')
}

function createBacteremias (p) {
  return common.createList(p, createBacteremia, 5, 'bact')
}

function createPneumopathies (p) {
  return common.createList(p, createPneumopathy, 5, 'pneu')
}

function createBmrBHres (p) {
  return common.createList(p, createBmrBHre, 4, 'bmrBHre')
}

function getSeverityScoreNameAndValue (valIgsII, valPimII) {
  if (valIgsII === undefined || valPimII === undefined) {
    return { n: null, v: undefined }
  }

  if (valIgsII !== '' && valIgsII !== null) {
    return { n: 'igsII', v: valIgsII }
  }
  if (valPimII !== '' && valPimII !== null) {
    return { n: 'pimII', v: valPimII }
  }

  return { n: null, v: null }
}

function createPatient (year, p) {
  const sc = getSeverityScoreNameAndValue(p.igsII, p.pimII)
  const scOther = common.getOtherSeverityScoreAndValue(p.otherScoreName, p.otherScoreValue)

  return {
    sheetNumber: p.sheetNumber,
    uf: (p.uf != null && p.uf !== '') ? p.uf.toString() : null,
    unitType: common.getUnitTypeCode(year, p.unitType),
    birthdate: common.newDate(p.birthdate),
    sex: common.getValue(p.sex, [1, 2, 3, 9]),
    entry: common.newDate(p.entry),
    origin: common.getValue(p.origin, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]),
    trauma: common.getValue(p.trauma, [1, 2, 9]),
    diagnosis: common.getValue(p.diagnosis, [1, 2, 3, 9]),
    immuno: common.getValue(p.immuno, [1, 2, 3, 9]),
    cancer: common.getValue(p.cancer, [1, 2, 3, 9]),
    antibio: common.getValue(p.antibio, [1, 2, 9]),
    bmi: common.nullIfEmpty(p.bmi),
    mainSeverity: common.getSeverity(sc.v, sc.n),
    otherSeverity: common.getSeverity(scOther.v, scOther.n),
    portageBmrBhre: common.getValue(p.portageBmrBhre, [1, 2, 9]),
    bmrBHreMicroOrgs: [],
    ecmo: common.getValue(p.ecmo, [1, 2, 3, 9]),
    intubated: common.getValue(p.intubated, [1, 2, 9]),
    intubStart: common.newDate(p.intubStart),
    reintubated: common.getValue(p.reintubated, [1, 2, 9]),
    intubEnd: common.newDate(p.intubEnd),
    urinary: common.getValue(p.urinary, [1, 2, 9]),
    urinaryStart: common.newDate(p.urinaryStart),
    urinaryEnd: common.newDate(p.urinaryEnd),
    dead: common.getValue(p.dead, [1, 2, 9]),
    death: common.newDate(p.death),
    exit: common.newDate(p.exit),
    covidStatus: common.getValue(p.covidStatus, [1, 2, 3, 9]),
    catheters: [],
    bacteremias: [],
    pneumopathies: []
  }
}

function createSheet (year, p) {
  const sheet = createPatient(year, p)
  sheet.catheters = createCatheters(p)
  sheet.bacteremias = createBacteremias(p)
  sheet.pneumopathies = createPneumopathies(p)
  sheet.bmrBhreMicroOrgs = createBmrBHres(p)

  common.checkMissingColumns(sheet)

  return sheet
}

export default {
  createSheet: createSheet,
  createPatient: createPatient,
  createCatheter: (p) => createCatheter('', p),
  createBmrBHre: (p) => createBmrBHres(p),
  createPneumopathy: (p) => createPneumopathy('', p),
  createBacteremia: (p) => createBacteremia('', p)
}
